import styled from "styled-components";

export const ReactLoadingContainer = styled.div`
  padding-left: 43%;
`;
